module.exports = __webpack_public_path__ + "img/second-1.52ce6761.webp";